import { useConfig as hook } from '@eika-infrastruktur/config-provider';
import { nbTranslations, nnTranslations } from './translations';
export const defaultConfig = {
    links: {},
    siteLang: 'nb',
    translations: {
        nb: nbTranslations,
        nn: nnTranslations,
    },
    featureToggles: {
        enableDetailsKredittbanken: false,
        enableCreditCardConfirmationScreen: false,
        enableCreditCardEmployeeApplication: false,
        addNorDirekteClient: false,
    },
    defaultInterestRate: 0.147,
    defaultLoanAmount: 150000,
    defaultLoanDuration: 5,
};
function createHook() {
    return () => hook();
}
export const useConfig = createHook();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdENvbmZpZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9kZWZhdWx0Q29uZmlnLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxTQUFTLElBQUksSUFBSSxFQUFjLE1BQU0scUNBQXFDLENBQUM7QUFFcEYsT0FBTyxFQUEwQixjQUFjLEVBQUUsY0FBYyxFQUFFLE1BQU0sZ0JBQWdCLENBQUM7QUEwQ3hGLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBVztJQUNqQyxLQUFLLEVBQUUsRUFBRTtJQUNULFFBQVEsRUFBRSxJQUFhO0lBQ3ZCLFlBQVksRUFBRTtRQUNWLEVBQUUsRUFBRSxjQUFjO1FBQ2xCLEVBQUUsRUFBRSxjQUFjO0tBQ3JCO0lBQ0QsY0FBYyxFQUFFO1FBQ1osMEJBQTBCLEVBQUUsS0FBSztRQUNqQyxrQ0FBa0MsRUFBRSxLQUFLO1FBQ3pDLG1DQUFtQyxFQUFFLEtBQUs7UUFDMUMsbUJBQW1CLEVBQUUsS0FBSztLQUM3QjtJQUNELG1CQUFtQixFQUFFLEtBQUs7SUFDMUIsaUJBQWlCLEVBQUUsTUFBTTtJQUN6QixtQkFBbUIsRUFBRSxDQUFDO0NBQ3pCLENBQUM7QUFFRixTQUFTLFVBQVU7SUFDZixPQUFPLEdBQUcsRUFBRSxDQUFDLElBQUksRUFBSyxDQUFDO0FBQzNCLENBQUM7QUFFRCxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsVUFBVSxFQUF3QixDQUFDIn0=